import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	overflow: auto;
`;

export const title = styled.p`
	font-size: 1.8rem;
	font-weight: 900;
	color: ${color.system.info};
`;

export const centralize = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const noProviders = styled.p`
	font-size: 1.6rem;
	font-weight: 900;
	color: ${color.interface.darkgray};
`;

export const lists = styled.div`
	width: 100%;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 2rem;
`;

export const list = styled.div`
	width: 99.8%;
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
`;

export const item = styled.div`
	background-color: ${color.interface.lightGray4};
	padding: 1.5rem;
	border-radius: 5px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;

	> p,
	b {
		font-size: 1.4rem;
		color: ${color.interface.darkgray};
	}
`;

export const infos = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	> p,
	b {
		font-size: 1.4rem;
		color: ${color.interface.darkgray};
	}
`;

export const btns = styled.div`
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;
